const DB_DATE_FORMAT_REGEX = /\d\d\d\d\-\d\d\-\d\d/;
const UI_DATE_FORMAT_REGEX = /\d\d\/\d\d\/\d\d\d\d/;

export const getOrganizationInfo = (organization) => {
  if (!organization) return;

  const isRoot = !organization.parent_id;
  const isChild = !isRoot;
  const hasChildren = organization.child_count !== 0;
  let isOrg;

  if (hasChildren) {
    isOrg = true;
  } else {
    isOrg = !organization.group_id || organization.template === 1;
  }

  return {
    isRoot,
    isChild,
    hasChildren,
    isOrg,
    isGroup: !isOrg
  };
};

export const formatDate = dateString => {
  if (UI_DATE_FORMAT_REGEX.test(dateString)) return dateString;

  if (!DB_DATE_FORMAT_REGEX.test(dateString)) return '';

  const [year, month, day] = dateString.split('-');
  return `${month}/${day}/${year}`;
};
